import TemplateView from '../../TemplateView'
import {isOrderFullyExistsAtTheBeginningOf} from '../../atUtils'
import CommentRow from './CommentRow'
import {UserInitialsIconColorPalette} from './UserInitialsIconColorPalette'
import {LOGGED_IN_USER_ICON_COLOR} from './constants'

export default class CommentsList extends TemplateView {
    constructor({
        startEditComment = (id) => {},
        cancelEditComment = () => {},
        updateEditingCommentText = (text) => {},
        saveEditingComment = () => {},
        onCommentDeleted = commentId => {},
        refreshScrollCb = () => {},
    }) {
        super()

        this.callbacks = {
            startEditComment,
            cancelEditComment,
            updateEditingCommentText,
            saveEditingComment,
            onCommentDeleted,
            refreshScrollCb,
        }

        this.state = {
            loggedInUser: null,
            users: {},
            comments: [],
            commentsCount: 0,
            allCommentsUserIds: [],
            isNewCommentsOnTop: true,
            recentlyAddedCommentsIds: {},
            editingCommentId: null,
            editingCommentText: '',
            updatingCommentId: null,
            readOnly: false,
            canManage: false,
        }

        this.colorPalette = new UserInitialsIconColorPalette()
        this.userIdColorsMap = {}
        this.commentRows = {}

        this.onStatePropertyChanged('loggedInUser', loggedInUser => {
            this.userIdColorsMap[loggedInUser.id] = LOGGED_IN_USER_ICON_COLOR
        })

        this.onAnyStatePropertyChanged(['users', 'comments', 'allCommentsUserIds'], (state, prevState) => {
            if (!isOrderFullyExistsAtTheBeginningOf(prevState.comments, state.comments)) {
                this.getEl().empty()
                this.commentRows = {}
            }
            this._updateCommentRows()
        })
        this.onStatePropertyChanged('editingCommentId', (id, prevId) => this._updateEditingComment(id, prevId))
        this.onStatePropertyChanged('updatingCommentId', (id, prevId) => this._updateUpdatingComment(id, prevId))
        this.onAnyStatePropertyChanged(['recentlyAddedCommentsIds', 'readOnly', 'canManage'], () => this._updateCommentRows())
    }

    templateHtml() {
        return "<div class='commentsList'/>"
    }

    _updateUsersColors() {
        this.state.allCommentsUserIds
            .filter(id => !this.userIdColorsMap[id])
            .forEach(id => this.userIdColorsMap[id] = this.colorPalette.getNextColor())
    }

    _updateCommentRows() {
        this._updateUsersColors()

        this.state.comments.forEach(comment => {
            if (!this.commentRows[comment.id]) {
                this.commentRows[comment.id] = new CommentRow({
                    id: comment.id,
                    userInfo: this.state.users[comment.userId],
                    color: this.userIdColorsMap[comment.userId],
                    onDeleteIconClickCb: id => this._handleCommentDeleteClick(id),
                    onCommentDeleted: this.callbacks.onCommentDeleted,
                    onCommentEditStart: this.callbacks.startEditComment,
                    onCancelEdit: this.callbacks.cancelEditComment,
                    onCommentSave: this.callbacks.saveEditingComment,
                    onEditingTextChanged: this.callbacks.updateEditingCommentText,
                    refreshScrollCb: this.callbacks.refreshScrollCb,
                }).init(this.getEl())
            }

            this._updateRowState(comment)
        })
    }

    _updateRowState(comment) {
        this.commentRows[comment.id].setState({
            creationTimestamp: comment.creationTimestamp,
            updatingUser: this.state.users[comment.updatingUserId],
            updatingTimestamp: comment.updatingTimestamp,
            text: comment.text,
            canEdit: !this.state.readOnly && (this.state.canManage || comment.userId === this.state.loggedInUser.id),
            recentlyAdded: this.state.recentlyAddedCommentsIds[comment.id] === true,
            updating: this.state.updatingCommentId === comment.id,
        })
    }

    _updateEditingComment(id, prevId) {
        if (prevId !== null)
            this.commentRows[prevId].setState({inEdit: false})

        if (id !== null) {
            this.commentRows[id].setState({inEdit: true})
        }
    }

    _updateUpdatingComment(id, prevId) {
        if (prevId !== null)
            this.commentRows[prevId].setState({updating: false})

        if (id !== null) {
            this.commentRows[id].setState({updating: true})
        }
    }

    _handleCommentDeleteClick(id) {
        if (this.state.editingCommentId !== null && this.state.editingCommentId !== id && this.state.updatingCommentId === null) {
            this.callbacks.saveEditingComment()
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/comments/CommentsList.js